;
define("merchandising_zone_row_template.tpl", function(){});

